import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProductionProgram from '../../components/ProductionProgram';
import { Route } from 'react-router-dom';
import { PRODUCTIONPROGRAM } from '../../routes';

const ProductionProgramRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PRODUCTIONPROGRAM}
				render={props => <ProductionProgram {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProductionProgramRoute;
